//for customer after scanning QR code

import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import axios from "axios";
import "../styles/BatchInfo.css"; // Import the CSS file
import cowBackground from "../assets/images/cow-background.jpg"; // Import image from src/assets
import logo from "../assets/images/NZ-Pure-Dairy-Logo.svg"; // Import logo
import Footer from "../components/Footer";
import { formatDateForDisplay } from "../utils/dateUtils";


const API_BASE_URL = "https://nzpdp-traceability-system-production-c63a.up.railway.app"; // Change when deploying

const BatchInfo = () => {
  const [batchInfo, setBatchInfo] = useState(null);
  const [error, setError] = useState(null);
  const [searchParams] = useSearchParams();
  const batchCode = searchParams.get("code");

  useEffect(() => {
    if (batchCode) {
      axios
        .get(`${API_BASE_URL}/api/get_batch_info?code=${batchCode}`)
        .then((response) => {
          setBatchInfo(response.data);
        })
        .catch(() => {
          setError("Unable to retrieve batch information. Please check the QR code or try again later.");
        });
    }
  }, [batchCode]);



  return (
    <>
    <div
      className="batch-container"
      style={{ backgroundImage: `url(${cowBackground})` }}
    >
      <div className="batch-card">
     
        <div className="logo-container">
          <img src={logo} alt="NZ Pure Dairy Logo" className="logo" />
        </div>

        <h1>Batch Information</h1>

        {error && <p className="error-message">{error}</p>}
        {batchInfo ? (
          <div className="batch-details">
            <p><strong>Product Name:</strong> {batchInfo.product_name}</p>
            <p><strong>Batch Number:</strong> {batchInfo.batch_no}</p>
            <p><strong>Manufacturer:</strong> {batchInfo.manufacturer}</p>
            <p><strong>Brand:</strong> {batchInfo.brand}</p>
            <p><strong>Origin:</strong> {batchInfo.origin}</p>
            <p><strong>Net Weight:</strong> {batchInfo.net_weight}</p>
            <p><strong>Shelf Life:</strong> {batchInfo.shelf_life} months</p>
            <p><strong>Manufacture Date:</strong> {formatDateForDisplay(batchInfo.manufacture_date)}</p>
            <p><strong>Expiry Date:</strong> {formatDateForDisplay(batchInfo.expiry_date)}</p>
          </div>
        ) : (
          <p className="loading-message">Loading...</p>
        )}

  
        <div className="marketing-button-container">
          <a 
            href="https://www.nzpuredairy.co.nz/other-products/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="marketing-button"
          >
            Visit Our Website
          </a>
        </div>
      </div>
    </div>

<Footer />
 </>
  );
};

export default BatchInfo;
